import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wrench } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const BG = "/login-bg.jpg?v=2";

export default function Login() {
  const { login } = useAuth();
  const { logoSrc } = useSettings();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@sto.ua");
  const [password, setPassword] = useState("admin123");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-background">
      <div className="hidden lg:block relative flex-1">
        <img src={BG} alt="Автосервіс" className="absolute inset-0 w-full h-full object-cover" />
      </div>

      <div className="w-full lg:w-[480px] flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div
            className="h-20 w-full max-w-[260px] mx-auto mb-6"
            style={{
              backgroundColor: "var(--brand)",
              WebkitMaskImage: `url(${logoSrc || "/viwat-logo.svg"})`,
              maskImage: `url(${logoSrc || "/viwat-logo.svg"})`,
              WebkitMaskRepeat: "no-repeat",
              maskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              maskPosition: "center",
              WebkitMaskSize: "contain",
              maskSize: "contain",
            }}
            data-testid="login-logo"
          />
          <h1 className="font-head font-black text-3xl mb-1 text-center">Вхід у систему</h1>
          <p className="text-muted-foreground text-sm mb-8 text-center">Введіть свої дані для входу</p>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} data-testid="login-email"
                onChange={(e) => setEmail(e.target.value)} className="mt-1.5" required />
            </div>
            <div>
              <Label htmlFor="password">Пароль</Label>
              <Input id="password" type="password" value={password} data-testid="login-password"
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5" required />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? "Вхід..." : "Увійти"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
